import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewEncapsulation,
} from "@angular/core";
import { DatapointsPageStateService } from "../../datapoints-page-state.service";
import { DatasetUtils } from "../../../../core/utils/dataset-utils";
import { Dataset } from "../../../../model/dataset/dataset";
import { DatasetField } from "../../../../model/dataset/field/dataset-field";
import { DatapointFilter } from "../../../../model/datapoint/filter/datapoint-filter";
import { DatapointProjection } from "../../../../model/datapoint/projection/datapoint-projection";
import { ReportRow } from "../../../../model/datapoint/report/count/report-row";
import { Sort } from "@angular/material/sort";
import { ReportDisplayType } from "../../../../model/analytics/report-display-type";
import { DatasetFieldType } from "../../../../model/dataset/dataset-field-type";
import { DatapointsService } from "../../../../data-access-layer/datapoints/datapoints.service";
import { ProjectedDatapoint } from "../../../../model/datapoint/projected-datapoint";
import { DatapointFilterObject } from "../../../../model/datapoint/datapoint-filter-object";
import { SortOrder } from "../../../../model/filter/draft-filter-sort";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { DatapointsFilterService } from "../../datapoints-filter.service";
import { Subscription } from "rxjs";
import { DatasetFieldSpecificType } from "../../../../model/dataset/dataset-field-specific.type";
import {
    TableColumn,
    TableColumnType,
    TableColumnAlignment,
} from "../../../../model/upload/table/table-column";
import { TableRow } from "../../../../model/upload/table/table-row";
import { TableCell } from "../../../../model/upload/table/table-cell";
import { DownloadReportItem } from "../../../../model/download/item/download-report-item";
import { DownloadReportTableRequest } from "../../../../model/download/download-report-table-request";
import { ReportComponent } from "../report.component";
import { DateUtils } from "../../../../core/utils/date-utils";
import { NumberUtils } from "../../../../core/utils/number-utils";
import { WorkspaceItem } from "../../../../model/workspace/workspace-item";
import { DatasetFieldScope } from "../../../../model/dataset/dataset-field-scope";
import { NotifService } from "../../../../core/notification/notif.service";
import { isUndefined } from "src/app/core/utils/util-master";
import { ReportType } from "src/app/model/analytics/report-type";
import { ChartDisplayType } from "src/app/model/analytics/chart-display-type";
import { TreeStructureUtils } from "src/app/core/utils/tree-structure-utils";
import { Datapoints } from "../../datapoints";
import { DatasetGeometryType } from "src/app/model/dataset/dataset-geometry-type";
import { MaptycsApplication } from "src/app/model/account/maptycs-application";
import { AnayticsConstants } from "src/app/constants";
import { AnalyticsUtils } from "src/app/core/analytics/analytics-utils";
import { RandomUtils } from "src/app/core/utils/random-utils";
import { ObjectUtils } from "src/app/core/utils/object-utils";
import { TreeNode, TreeStructure } from "src/app/model/menu/tree-structure";

@Component({
    selector: "map-ranking-report",
    templateUrl: "./ranking-report.component.html",
    styleUrls: ["./ranking-report.component.scss"],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RankingReportComponent
    implements OnInit, OnDestroy, ReportComponent
{
    @Input() uuid: string;
    @Output() closed = new EventEmitter();
    @Output() saveWorkspaceItemToDashboard = new EventEmitter();
    @Output() saveAsWorkspaceItemToDashboard = new EventEmitter();
    @Output() saveSorting = new EventEmitter();
    @Input() set dataset(dataset: Dataset) {
        this._dataset = JSON.parse(JSON.stringify(dataset));
        this._dataset.fields.forEach((field) => (field.selected = false));
    }

    /**
     * Filter overlay tree nodes to numeric-only fields and prune empty groups
     */
    private filterNumericOverlayNodes(nodes: any[]): any[] {
        if (!nodes || nodes.length === 0) return [];

        const isNumericField = (field: any): boolean => {
            if (!field) return false;
            const baseType = field.baseType ?? field.params?.field?.baseType;
            const type = field.type ?? field.params?.field?.type;
            return baseType === 'NUMBER' || type === DatasetFieldSpecificType.NUMBER_FIELD;
        };

        const prune = (items: any[]): any[] => {
            const result: any[] = [];
            for (const item of items) {
                // Leaf node (has params.field)
                if (item?.params?.field) {
                    if (isNumericField(item.params.field)) {
                        result.push(item);
                    }
                    continue;
                }
                // Group node: recurse children and keep only non-empty groups
                if (item?.children && Array.isArray(item.children)) {
                    const keptChildren = prune(item.children);
                    if (keptChildren.length > 0) {
                        result.push({ ...item, children: keptChildren });
                    }
                }
            }
            return result;
        };

        return prune(nodes);
    }
    @Input() set formulas(formulas: WorkspaceItem[]) {
        this._formulas = formulas;
    }
    @Input() set nriFields(nriFields: any) {
        this._nriFields = JSON.parse(JSON.stringify(nriFields));
    }
    @Input() set climateOverlays(climateOverlays: any) {
        this._climateOverlays = JSON.parse(JSON.stringify(climateOverlays));
    }

    @Input() fromAnalytics: boolean = true;

    @Input() dashboardWorkspaceItems: WorkspaceItem[];
    @Input() isDashboardCall: boolean;
    @Input() set groups(groups: any) {
        if (groups !== undefined && groups !== null) {
            this._groups = JSON.parse(JSON.stringify(groups));
            this._compareGroups = ObjectUtils.clone(this._groups);
            this._withGroups = ObjectUtils.clone(this._groups);
        }
    }
    ulClassName = 'compareGroups';
    @Input() set groupsStrcuture(groupsStrcuture: TreeStructure[]) {
        if (groupsStrcuture !== undefined && groupsStrcuture !== null) {
            this._groupsStrcuture = groupsStrcuture;
            this._compareGroupsStrcuture = ObjectUtils.clone(this._groupsStrcuture);
            this._withGroupsStrcuture = ObjectUtils.clone(this._groupsStrcuture);
        }
    }
    @Input() isComparisonModeActivated: boolean;
    get AnayticsConstants() {
        return AnayticsConstants;
    }
    private LIMIT: number = 247;
    analyticsUtils = new AnalyticsUtils();
    _groups = [];
    _compareGroups = [];
    _withGroups = [];
    _groupsStrcuture: any[] = [];
    _compareGroupsStrcuture: any[] = [];
    _withGroupsStrcuture: any[] = [];
    isCompareDropdownOpen: boolean = true;
    isCompareWithDropdownOpen: boolean = true;
    _dataset: Dataset;
    _nriFields: any;
    _climateOverlays: any;
    selectedRankingField: DatasetField;
    selectedRankingFieldOverlay?: Dataset;
    selectedFields: DatasetField[] = [];
    selectedFieldsByDataset: Map<string, DatasetField[]> = new Map();
    noOfItems: number;
    reportName: string;
    datasetFields: DatasetField[];
    reportType: string = ReportType.RANKING;
    reportSubType: ReportDisplayType = ReportDisplayType.TABLE;
    chartDisplayType: ChartDisplayType = ChartDisplayType.NONE;
    dataIsReady = false;
    datapointFilter: DatapointFilter;
    datapointProjection: DatapointProjection;
    tessadataFields: {
        nriFields: DatasetField[];
        externalFields: DatasetField[];
  //      tensorflightFields: DatasetField[];
        preciselyBuildingFields: DatasetField[];
        preciselyCrimeFields: DatasetField[];
        preciselyWildfireRiskFields: DatasetField[];
        munichreFields: DatasetField[];
        customScoreFields: DatasetField[];
        e2valueFields: DatasetField[];
        consolidatedRiskScoreFields: DatasetField[];
    };
    tessadataGroupedFields: any[];
    _formulas: WorkspaceItem[] = [];
    selectedFormula: WorkspaceItem;

    /** TABLE  */
    dynamicColumns: Map<string, string>; // key of the map is the fieldId, value is field value
    columnsToDisplay: string[];
    parentColumns: string[] = ['group1', 'group2'];
    sumsByFieldId: Map<string, number> = new Map<string, number>();
    reportData: ReportRow[];
    downloadReportData: ReportRow[];

    readonly RANKING_COLUMN_ID = "ranking";
    readonly TOTAL_COLUMN_ID = "total";
    readonly BLANK_COLUMN_ID = "blank";
    private readonly subscriptions: Subscription = new Subscription();
    private static compare(a: any, b: any, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
    sort: Sort= {
        active: '',
        direction: ''
    };
    rankingTreeStrcuture = new TreeStructureUtils();
    rankingTreeControl = this.rankingTreeStrcuture.getTreeControl();
    rankingDataSource = this.rankingTreeStrcuture.getDataSource();

    columnsToDisplayTreeStrcuture = new TreeStructureUtils();
    columnsToDisplayTreeControl = this.columnsToDisplayTreeStrcuture.getTreeControl();
    columnsToDisplayDataSource = this.columnsToDisplayTreeStrcuture.getDataSource();

    datapointObject = new Datapoints();
    constructor(
        private readonly datapointsPageStateService: DatapointsPageStateService,
        private readonly datapointsFilterService: DatapointsFilterService,
        private readonly datapointService: DatapointsService,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly notif: NotifService
    ) {}

    ngOnInit() {
        this.resetNRISelectedFlag();
        this._dataset.fields = this.sortFields(
            JSON.parse(JSON.stringify(this._dataset.fields))
        );
        this.datasetFields = this.sortFields(
            JSON.parse(JSON.stringify(this._dataset.fields))
        );
        this.tessadataFields = JSON.parse(
            JSON.stringify(
                this.datapointsPageStateService.getActiveTessadataFields()
            )
        );
        this.tessadataFields.externalFields.forEach(
            (field) => (field.selected = false)
        );
        this.tessadataFields.nriFields = this.sortFields(
            this.tessadataFields.nriFields
        );
        if (
            this.tessadataFields.externalFields &&
            this.tessadataFields.externalFields.length > 0
        ) {
            let externalDataset = this.sortFields(
                this.tessadataFields.externalFields
            );
            this.tessadataGroupedFields = externalDataset.reduce(
                (groups, item) => ({
                    ...groups,
                    [item.tags[0]]: [...(groups[item.tags[0]] || []), item],
                }),
                []
            );
            for (const key in this.tessadataGroupedFields) {
                if (
                    Object.prototype.hasOwnProperty.call(
                        this.tessadataGroupedFields,
                        key
                    )
                ) {
                    this.tessadataGroupedFields[key] = this.sortFields(
                        this.tessadataGroupedFields[key]
                    );
                }
            }
        }

        this.tessadataFields.preciselyBuildingFields.forEach(
            (field) => (field.selected = false)
        );
        if (
            this.tessadataFields.preciselyBuildingFields &&
            this.tessadataFields.preciselyBuildingFields.length > 0
        ) {
            let preciselyDataset = this.sortFields(
                this.tessadataFields.preciselyBuildingFields
            );
            let preciselyGroupFields = preciselyDataset.reduce(
                (groups, item) => ({
                    ...groups,
                    [item.tags[0]]: [...(groups[item.tags[0]] || []), item],
                }),
                []
            );
            this.tessadataGroupedFields = !isUndefined(this.tessadataGroupedFields) && Object.keys(this.tessadataGroupedFields).length ? {...this.tessadataGroupedFields, ...preciselyGroupFields} : preciselyGroupFields;
        }
        this.tessadataFields.preciselyCrimeFields.forEach(
            (field) => (field.selected = false)
        );
        if (
            this.tessadataFields.preciselyCrimeFields &&
            this.tessadataFields.preciselyCrimeFields.length > 0
        ) {
            let preciselyCrimeDataset = this.sortFields(
                this.tessadataFields.preciselyCrimeFields
            );
            let preciselyCrimeGroupFields = preciselyCrimeDataset.reduce(
                (groups, item) => ({
                    ...groups,
                    [item.tags[0]]: [...(groups[item.tags[0]] || []), item],
                }),
                []
            );
            this.tessadataGroupedFields = !isUndefined(this.tessadataGroupedFields) && Object.keys(this.tessadataGroupedFields).length ? {...this.tessadataGroupedFields, ...preciselyCrimeGroupFields} : preciselyCrimeGroupFields;
        }
        this.tessadataFields.preciselyWildfireRiskFields.forEach(
            (field) => (field.selected = false)
        );
        if (
            this.tessadataFields.preciselyWildfireRiskFields &&
            this.tessadataFields.preciselyWildfireRiskFields.length > 0
        ) {
            let preciselyWildfireRiskDataset = this.sortFields(
                this.tessadataFields.preciselyWildfireRiskFields
            );
            let preciselyWildfireRiskGroupFields = preciselyWildfireRiskDataset.reduce(
                (groups, item) => ({
                    ...groups,
                    [item.tags[0]]: [...(groups[item.tags[0]] || []), item],
                }),
                []
            );
            this.tessadataGroupedFields = !isUndefined(this.tessadataGroupedFields) && Object.keys(this.tessadataGroupedFields).length ? {...this.tessadataGroupedFields, ...preciselyWildfireRiskGroupFields} : preciselyWildfireRiskGroupFields;
        }
       // this.tessadataFields.tensorflightFields.forEach(
       //     (field) => (field.selected = false)
       // );
        // if (
        //     this.tessadataFields.tensorflightFields &&
        //     this.tessadataFields.tensorflightFields.length > 0
        // )
        {
            // let tensorflightDatasets = this.sortFields(
            //     this.tessadataFields.tensorflightFields
            // );
            // let tensorflightGroupFields = tensorflightDatasets.reduce(
            //     (groups, item) => ({
            //         ...groups,
            //         [item.tags[0]]: [...(groups[item.tags[0]] || []), item],
            //     }),
            //     []
            // );
            this.tessadataGroupedFields = !isUndefined(this.tessadataGroupedFields) && Object.keys(this.tessadataGroupedFields).length ? {...this.tessadataGroupedFields, /* ...tensorflightGroupFields */} : null /* tensorflightGroupFields*/;
        }

        this.tessadataFields.e2valueFields.forEach(
            (field) => (field.selected = false)
        );
        if (
            this.tessadataFields.e2valueFields &&
            this.tessadataFields.e2valueFields.length > 0
        ) {
            let e2valueDatasets = this.sortFields(
                this.tessadataFields.e2valueFields
            );
            let e2valueGroupFields = e2valueDatasets.reduce(
                (groups, item) => ({
                    ...groups,
                    [item.tags[0]]: [...(groups[item.tags[0]] || []), item],
                }),
                []
            );
            this.tessadataGroupedFields = !isUndefined(this.tessadataGroupedFields) && Object.keys(this.tessadataGroupedFields).length ? {...this.tessadataGroupedFields, ...e2valueGroupFields} : e2valueGroupFields;
        }

        this.tessadataFields.customScoreFields.forEach(
            (field) => (field.selected = false)
        );
        if (
            this.tessadataFields.customScoreFields &&
            this.tessadataFields.customScoreFields.length > 0
        ) {
            let customScoreDatasets = this.sortFields(
                this.tessadataFields.customScoreFields
            );
            let customScoreGroupFields = customScoreDatasets.reduce(
                (groups, item) => ({
                    ...groups,
                    [item.tags[0]]: [...(groups[item.tags[0]] || []), item],
                }),
                []
            );
            this.tessadataGroupedFields = !isUndefined(this.tessadataGroupedFields) && Object.keys(this.tessadataGroupedFields).length ? {...this.tessadataGroupedFields, ...customScoreGroupFields} : customScoreGroupFields;
        }


        this.tessadataFields.munichreFields.forEach(
            (field) => (field.selected = false)
        );
        if (
            this.tessadataFields.munichreFields &&
            this.tessadataFields.munichreFields.length > 0
        ) {
            let munichreDatasets = this.sortFields(
                this.tessadataFields.munichreFields
            );
            let munichreGroupFields = munichreDatasets.reduce(
                (groups, item) => ({
                    ...groups,
                    [item.tags[0]]: [
                        ...(groups[item.tags[0]] || [])
                            .map(group => group[item.tags[1]] ? {
                                ...group, [item.tags[1]]:
                                    [...group[item.tags[1]], item]
                            } : group
                            ),
                        ...(groups[item.tags[0]]?.some(group => group[item.tags[1]]) ? [] : [{ [item.tags[1]]: [item] }])
                    ]
                }),
                []
            );
            this.tessadataGroupedFields = !isUndefined(this.tessadataGroupedFields) && Object.keys(this.tessadataGroupedFields).length ? {...this.tessadataGroupedFields, ...munichreGroupFields} : munichreGroupFields;
        }

        this.tessadataFields.consolidatedRiskScoreFields.forEach(
            (field) => (field.selected = false)
        );
        if (
            this.tessadataFields.consolidatedRiskScoreFields &&
            this.tessadataFields.consolidatedRiskScoreFields.length > 0
        ) {
            this.tessadataGroupedFields = DatasetUtils.mergeTagGroupedFields(
                this.sortFields(this.tessadataFields.consolidatedRiskScoreFields),
                this.tessadataGroupedFields
            );
        }

        this._formulas = JSON.parse(JSON.stringify(this._formulas));
        this.datapointFilter = this.datapointsFilterService.getActiveFilter();
        this.subscriptions.add(
            this.datapointsFilterService
                .onFilterChange()
                .subscribe((newFilter) => {
                    this.datapointFilter = newFilter;
                    if (this.dataIsReady) {
                        this.generateReportData();
                    }
                })
        );
        this.subscriptions.add(
            this.datapointsPageStateService.onDatapointsChanged().subscribe(() => {
                if (this.dataIsReady) {
                    this.generateReportData();
                }
            })
        );

        // ⭐ NEW: Prepare climate data with single-pass filtering for better performance
        // Parameters: (overlays, isProjectedCall, checkGeometryTypeComplexOnly, isPointOverlayRequired, filterByClimateChange)
        // filterByClimateChange=true filters overlays during transformation (single iteration)
        const preparedClimateData = this._climateOverlays 
            ? this.datapointObject.prepareClimateData(this._climateOverlays, false, false, true, true)
            : [];

        // ⭐ Split prepared climate data by geoWorkspace
        const climateChangeTree = this.filterPreparedClimateTreeByWorkspace(preparedClimateData, 'climate_change');
        const climatologyTree = this.filterPreparedClimateTreeByWorkspace(preparedClimateData, 'climatology');
        // ⭐ Add climate_change overlays to rankingDataSource (filter via shared filterAndDelete)
        const rankingClimate = this.datapointObject.filterAndDelete(climateChangeTree, { isNumberTypeCheck: true });
        // ⭐ Prepare formulas for ranking dropdown
        const preparedFormulas = this.datapointObject.prepareFormulas(this._formulas);
        this.rankingDataSource.data = [
            ...this.datapointObject.prepareDataset([this._dataset], this._dataset, {type: DatasetFieldSpecificType.NUMBER_FIELD}),
            ...preparedFormulas,
            ...rankingClimate
        ];
        
        let tessadataFieldsByDataset = {};
        tessadataFieldsByDataset[this._dataset.id] = {nriFields: []};
        tessadataFieldsByDataset[this._dataset.id].nriFields = this.nriFields;
        
        this.columnsToDisplayDataSource.data = [
            ...this.datapointObject.prepareDataset([this._dataset], this._dataset),
            ...this.datapointObject.prepareTesadata(this.tessadataGroupedFields, this._dataset),
            ...this.datapointObject.prepareNRIFields(
                [this._dataset],
                tessadataFieldsByDataset,
                true,
                this._dataset
            ),
            // ⭐ Add climatology overlays to columns list
            ...climatologyTree
        ]
        this.columnsToDisplayDataSource.data = this.datapointObject.filterAndDelete(this.columnsToDisplayDataSource.data, {isBothTypeCheck: true});
    }

    // Filter a prepared climate tree (TreeStructure[]) by overlay geoWorkspace value
    private filterPreparedClimateTreeByWorkspace(nodes: any[], workspace: string): any[] {
        if (!nodes || nodes.length === 0) return [];
        const filtered: any[] = [];
        nodes.forEach(node => {
            if (node.children && node.children.length > 0) {
                const newChildren = this.filterPreparedClimateTreeByWorkspace(node.children, workspace);
                if (newChildren.length > 0) {
                    filtered.push({ ...node, children: newChildren });
                }
            } else if (node.params && node.params.overlay && node.params.overlay.geoWorkspace === workspace) {
                filtered.push(node);
            }
        });
        return filtered;
    }

    onFilterAllClick(
        $event: MatCheckboxChange,
        fields: DatasetField[],
        isDatasetAllCheckboxSelected?: boolean,
        isLocations?: boolean
    ) {
        fields.forEach((field) => {
            if (
                (isLocations && field.scope !== this.datasetScope.INTERNAL) ||
                field.id === "created_on" ||
                field.id === "updated_on"
            ) {
                return;
            }
            if (
                this.selectedRankingField &&
                this.selectedRankingField.id === field.id
            ) {
                return;
            }
            if (field.selected && $event.checked === true) {
                let findExistingField = this.selectedFields.find(
                    (f) => f.id === field.id
                );
                if (findExistingField) {
                    let index = this.selectedFields.indexOf(findExistingField);
                    this.selectedFields.splice(index, 1);
                }
            }
            field.selected = $event.checked;
            this.onFieldsMenuClick($event.checked, field, undefined);
        });
    }

    isNotAllDatasetSelected(
        fields: DatasetField[],
        isLocations?: boolean
    ): boolean {
        if (isLocations) {
            return (
                fields.filter(
                    (field) =>
                        !field.selected &&
                        field.scope === this.datasetScope.INTERNAL &&
                        field.id !== "created_on" &&
                        field.id !== "updated_on"
                ).length > 0
            );
        } else {
            return fields.filter((field) => !field.selected).length > 0;
        }
    }

    onFieldsMenuClick(fieldSelected: boolean, field: DatasetField, overlay?: Dataset) {
        // ⭐ NEW: If overlay is provided, track in selectedFieldsByDataset ONLY (for projection.links)
        if (overlay) {
            const validDataset = overlay;
            let datasetFields = this.selectedFieldsByDataset.get(validDataset.id);
            if (!datasetFields) {
                datasetFields = [];
            }
            if (fieldSelected) {
                datasetFields.push(field);
            } else {
                datasetFields = datasetFields.filter((f) => f.id !== field.id);
            }
            if (datasetFields.length === 0) {
                this.selectedFieldsByDataset.delete(validDataset.id);
            } else {
                this.selectedFieldsByDataset.set(validDataset.id, datasetFields);
            }
        } else {
            // ✅ EXISTING LOGIC - For primary dataset fields (goes to projection.fields)
            if (fieldSelected) {
                this.selectedFields.push(field);
            } else {
                this.selectedFields.splice(this.selectedFields.indexOf(field), 1);
            }
        }
    }

    get datasetScope() {
        return DatasetFieldScope;
    }

    generateReport() {
        if (
            (this.selectedFields.length > 0 || this.selectedFieldsByDataset.size > 0 || this.hasOverlayColumnsSelected()) &&
            (this.selectedRankingField || this.selectedFormula) &&
            this.noOfItems
        ) {
            this.generateReportData();
        } else {
            this.dataIsReady = false;
        }
    }

    getSelectedRankingField() {
        return this.selectedRankingField;
    }
    
    getSelectedRankingFieldOverlay(): Dataset {
        return this.selectedRankingFieldOverlay;
    }

    generateReportData() {
        // Validate: either a ranking field OR a formula must be selected (mutually exclusive)
        if (!this.selectedRankingField && !this.selectedFormula) {
            this.notif.error(
                "Please select a ranking field or formula."
            );
            return;
        }

        this.prepareProjection();
        this.populateTableColumnsList();
        this.sort.direction = 'asc';
        let datapointsRequest = this.createDatapointRequest();
        if (this.isComparisonModeActivated && this.getSelectedGroups().length === AnayticsConstants.MAX_GROUP_SELECT_LIMIT) {
            this.subscriptions.add(
                this.datapointService
                    .getDatapointsByFilterForComparison(datapointsRequest)
                    .subscribe((datapoints) => {
                        const displayLimit = this.noOfItems ? Math.min(this.noOfItems, 247) : 247;
                        const limited = datapoints.slice(0, displayLimit);
                        this.computeTotalSumsForComparison(limited);
                        this.convertDataToTableFormat(limited);
                        this.populateTableColumnsList();
                        if (this.sort && !isUndefined(this.sort)) {
                            this.sortData(this.sort);
                        }

                        this.dataIsReady = true;
                        this.changeDetector.detectChanges();
                    })
            )
        } else {
            this.subscriptions.add(
                this.datapointService
                    .getDatapointsByFilter(datapointsRequest)
                    .subscribe((datapoints) => {
                        const displayLimit = this.noOfItems ? Math.min(this.noOfItems, 247) : 247;
                        const limited = datapoints.slice(0, displayLimit);
                        this.computeTotalSums(limited);
                        this.convertDataToTableFormat(limited);
                        this.populateTableColumnsList();
                        if (this.sort && !isUndefined(this.sort)) {
                            this.sortData(this.sort);
                        }

                        this.dataIsReady = true;
                        this.changeDetector.detectChanges();
                    })
            );
        }
    }

    private createDatapointRequest(): DatapointFilterObject {
        const datapointFilters = this.analyticsUtils.generateDatapointFilter(this.datapointFilter, this._dataset, this.isComparisonModeActivated, this.getSelectedGroups());
        
        // Build sort object - use ranking field if selected, otherwise use formula
        const sortObj: any = {
            datasetID: this._dataset.id,
            fields: [],
        };
        
        if (this.selectedRankingField) {
            sortObj.fields = [
                {
                    id: this.selectedRankingField.id,
                    sortOrder: SortOrder.DESCENDANT,
                },
            ];
        } else if (this.selectedFormula) {
            // When sorting by formula, use formulaId instead of field
            sortObj.formulaId = this.selectedFormula.id;
        }
        
        return {
            filter: datapointFilters,
            limit: this.noOfItems ? this.noOfItems : 0,
            skip: 0,
            projection: this.datapointProjection,
            sort: sortObj,
        };
    }

    private populateTableColumnsList() {
        this.dynamicColumns = new Map();
        this.columnsToDisplay = [this.RANKING_COLUMN_ID];
        if (this.isComparisonModeActivated) {
            const selectedGroups = this.getSelectedGroups();
            selectedGroups.forEach(selectedGroup => {
                this.selectedFields.forEach((field) => {
                    const fieldName = field.displayName == null || field.displayName == undefined ? field.name : field.displayName;
                    this.dynamicColumns.set(field.id+'_'+selectedGroup?.id, fieldName + ' (' + selectedGroup?.name + ')');
                    this.columnsToDisplay.push(field.id+'_'+selectedGroup?.id);
                });
                
                // ⭐ NEW: Add climate overlay fields for comparison mode
                this.selectedFieldsByDataset.forEach((fields, datasetId) => {
                    fields.forEach((field) => {
                        const fieldName = field.displayName == null || field.displayName == undefined ? field.name : field.displayName;
                        const columnId = datasetId + '.' + field.id + '_' + selectedGroup?.id;  // Format: "climate_tx40.2_groupId"
                        this.dynamicColumns.set(columnId, fieldName + ' (' + selectedGroup?.name + ')');
                        this.columnsToDisplay.push(columnId);
                    });
                });
                
                if (this.selectedRankingField) {const fieldName = this.selectedRankingField.displayName == null || this.selectedRankingField.displayName == undefined ? this.selectedRankingField.name : this.selectedRankingField.displayName;
                    // ⭐ NEW: Use datasetID.fieldID format if ranking field is from climate overlay
                    const rankingFieldId = this.selectedRankingFieldOverlay 
                        ? this.selectedRankingFieldOverlay.id + '.' + this.selectedRankingField.id
                        : this.selectedRankingField.id;
                    const columnId = rankingFieldId + '_' + selectedGroup?.id;
                    this.dynamicColumns.set(columnId, fieldName + ' (' + selectedGroup?.name + ')');
                    this.columnsToDisplay.push(columnId);
                }
                if (this.selectedFormula) {
                    this.dynamicColumns.set(
                        this.selectedFormula.id.toString()+'_'+selectedGroup?.id,
                        this.selectedFormula.name + ' (' + selectedGroup?.name + ')'
                    );
                    this.columnsToDisplay.push(this.selectedFormula.id.toString()+'_'+selectedGroup?.id);
                }
            });
            this.dynamicColumns.set(
                selectedGroups[0]?.id+'_'+selectedGroups[1]?.id,
                selectedGroups[0]?.name+' vs '+ selectedGroups[1]?.name + ' (%)',
            );
            this.columnsToDisplay.push(selectedGroups[0]?.id+'_'+selectedGroups[1]?.id);
        } else {
            this.selectedFields.forEach((field) => {
                const fieldName = field.displayName == null || field.displayName == undefined ? field.name : field.displayName;
                this.dynamicColumns.set(field.id, fieldName);
                this.columnsToDisplay.push(field.id);
            });
            
            // ⭐ NEW: Add climate overlay fields to table columns
            this.selectedFieldsByDataset.forEach((fields, datasetId) => {
                fields.forEach((field) => {
                    const fieldName = field.displayName == null || field.displayName == undefined ? field.name : field.displayName;
                    const columnId = datasetId + '.' + field.id;  // Format: "climate_tx40.2"
                    this.dynamicColumns.set(columnId, fieldName);
                    this.columnsToDisplay.push(columnId);
                });
            });
            
            if (this.selectedRankingField) {
                const fieldName = this.selectedRankingField.displayName == null || this.selectedRankingField.displayName == undefined ? this.selectedRankingField.name : this.selectedRankingField.displayName;
                // ⭐ NEW: Use datasetID.fieldID format if ranking field is from climate overlay
                const columnId = this.selectedRankingFieldOverlay 
                    ? this.selectedRankingFieldOverlay.id + '.' + this.selectedRankingField.id
                    : this.selectedRankingField.id;
                this.dynamicColumns.set(columnId, fieldName);
                this.columnsToDisplay.push(columnId);
            }
            if (this.selectedFormula) {
                this.dynamicColumns.set(
                    this.selectedFormula.id.toString(),
                    this.selectedFormula.name
                );
                this.columnsToDisplay.push(this.selectedFormula.id.toString());
            }
        }
       this.dynamicColumns = this.analyticsUtils.sortMapDataForStringType(this.dynamicColumns);
    }

    computeTotalSumsForComparison(datapoints: ProjectedDatapoint[]) {
        this.sumsByFieldId = new Map<string, number>();
        this.parentColumns.forEach((column, index) => {
            datapoints.forEach((datapoint) => {
                const groupId = '_' + this.getSelectedGroups()[index]?.id;
                datapoint[column].forEach((field) => {
                    if (field.numberValue) {
                        if (!this.sumsByFieldId.get(field.id + groupId)) {
                            this.sumsByFieldId.set(field.id + groupId, field.numberValue);
                        } else {
                            this.sumsByFieldId.set(
                                field.id + groupId,
                                this.sumsByFieldId.get(field.id+ groupId) + field.numberValue
                            );
                        }
                    }
                });
                if (datapoint.formulaResults) {
                    if (
                        !this.sumsByFieldId.get(this.selectedFormula.id.toString() + groupId)
                    ) {
                        this.sumsByFieldId.set(
                            this.selectedFormula.id.toString() + groupId,
                            datapoint.formulaResults[0]
                        );
                    } else {
                        this.sumsByFieldId.set(
                            this.selectedFormula.id.toString() + groupId,
                            this.sumsByFieldId.get(
                                this.selectedFormula.id.toString() + groupId
                            ) + datapoint.formulaResults[0]
                        );
                    }
                }
            });
        })
        // ⭐ NEW: Use datasetID.fieldID format if ranking field is from climate overlay
        const rankingFieldId = this.selectedRankingFieldOverlay 
            ? this.selectedRankingFieldOverlay.id + '.' + this.selectedRankingField.id
            : this.selectedRankingField.id;
        const group1 = this.sumsByFieldId.get(rankingFieldId+'_'+this.getSelectedGroups()[0].id);
        const group2 = this.sumsByFieldId.get(rankingFieldId+'_'+this.getSelectedGroups()[1].id);
        let calculateResult = ((Number(group1) - Number(group2))/Number(group2)) * 100;
        calculateResult = isNaN(calculateResult) ? Number(0.00) : calculateResult;
        this.sumsByFieldId.set(this.analyticsUtils.getSlectedGroupColumnName(this.getSelectedGroups()), calculateResult);
        this.sumsByFieldId = this.analyticsUtils.sortMapDataForNumberType(this.sumsByFieldId);
    }
    private computeTotalSums(datapoints: ProjectedDatapoint[]) {
        this.sumsByFieldId = new Map<string, number>();
        datapoints.forEach((datapoint) => {
            datapoint.fields.forEach((field) => {
                if (field.numberValue) {
                    if (!this.sumsByFieldId.get(field.id)) {
                        this.sumsByFieldId.set(field.id, field.numberValue);
                    } else {
                        this.sumsByFieldId.set(
                            field.id,
                            this.sumsByFieldId.get(field.id) + field.numberValue
                        );
                    }
                }
            });
            if (datapoint.formulaResults) {
                if (
                    !this.sumsByFieldId.get(this.selectedFormula.id.toString())
                ) {
                    this.sumsByFieldId.set(
                        this.selectedFormula.id.toString(),
                        datapoint.formulaResults[0]
                    );
                } else {
                    this.sumsByFieldId.set(
                        this.selectedFormula.id.toString(),
                        this.sumsByFieldId.get(
                            this.selectedFormula.id.toString()
                        ) + datapoint.formulaResults[0]
                    );
                }
            }
        });
    }

    get DatasetFieldType() {
        return DatasetFieldType;
    }

    get DatasetFieldSpecificType() {
        return DatasetFieldSpecificType;
    }

    get ReportDisplayType() {
        return ReportDisplayType;
    }

    getSort(): Sort {
        return this.sort;
    }

    sortData(sort: Sort, isSortCall: boolean = false) {
        const isAsc = sort.direction === "asc";
        const fieldId = sort.active;
        if (isUndefined(this.sort)) {
            this.sort = {
                active: '',
                direction: ''
            };
        }
        this.sort.active = fieldId;
        this.sort.direction = sort.direction;

        let sortedData = this.reportData.sort((a, b) => {
            switch (fieldId) {
                case this.RANKING_COLUMN_ID:
                    return RankingReportComponent.compare(
                        a.ranking,
                        b.ranking,
                        isAsc
                    );
                default: {
                    let sanatizeValue = (item: any) => {
                        let value = item.dynamicFieldValuesByIds.get(fieldId);
                        return value === 'N/A' ? "" : value;
                    };

                    let aValue = sanatizeValue(a);
                    let bValue = sanatizeValue(b);

                    return RankingReportComponent.compare(
                        aValue,
                        bValue,
                        isAsc
                    );
                }
            }
        });

        this.reportData = [...sortedData];
        this.downloadReportData = this.reportData;
        if (isSortCall) {
            this.saveSorting.emit();
        }
    }

    private convertDataToTableFormat(datapoints: ProjectedDatapoint[]) {
        this.reportData = [];
        this.downloadReportData = [];
        let index = 1;
        datapoints.forEach((datapoint) => {
            let tableEntry: ReportRow = {
                dynamicFieldValuesByIds:
                this.isComparisonModeActivated ? this.getDynamicFieldValuesForComparisonByIds(datapoint) : this.getDynamicFieldValuesByIds(datapoint),
                ranking: index,
            };
            index++;
            this.downloadReportData.push(tableEntry);

        });
        this.reportData = this.downloadReportData;
    }

    private extractFieldValue(field: any): any {
        if (field.numberValue !== undefined && field.numberValue !== null) return field.numberValue;
        if (field.textValue) return field.textValue;
        if (field.datetimeValue) return DateUtils.parseDate(field.datetimeValue);
        if (field.textArrayValue) return field.textArrayValue;
        if (field.numberArrayValue) return NumberUtils.formatNumber(field.numberArrayValue);
        if (field.datetimeArrayValue) return DateUtils.parseDate(field.datetimeArrayValue);
        return "N/A";
    }

    getDynamicFieldValuesByIds(
        datapoint: ProjectedDatapoint
    ): Map<string, string> {
        const tableEntries: Map<string, string> = new Map<string, string>();
        datapoint.fields.forEach((field) => {
            tableEntries.set(field.id, this.extractFieldValue(field));
        });
        if (datapoint.formulaResults) {
            const value = this.isMissingValue(datapoint.formulaResults[0]) ? "N/A" : String(datapoint.formulaResults[0]);
            tableEntries.set(this.selectedFormula.id.toString(), value);
        }
        return tableEntries;
    }

    getDynamicFieldValuesForComparisonByIds(
        datapoint: ProjectedDatapoint
    ): Map<string, string> {
        const tableEntries: Map<string, string> = new Map<string, string>();
        const selectedGroups = this.getSelectedGroups();
        
        this.parentColumns.forEach((column, index) => {
            const groupId = selectedGroups[index]?.id;
            datapoint[column].forEach((field) => {
                tableEntries.set(`${field.id}_${groupId}`, this.extractFieldValue(field));
            });
            if (datapoint.formulaResults) {
                const value = this.isMissingValue(datapoint.formulaResults[0]) ? "N/A" : String(datapoint.formulaResults[0]);
                tableEntries.set(`${this.selectedFormula.id.toString()}_${groupId}`, value);
            }
        });
        
        if (this.selectedRankingField) {
            const rankingFieldId = this.selectedRankingFieldOverlay 
                ? `${this.selectedRankingFieldOverlay.id}.${this.selectedRankingField.id}`
                : this.selectedRankingField.id;
            const group1 = tableEntries.get(`${rankingFieldId}_${selectedGroups[0].id}`);
            const group2 = tableEntries.get(`${rankingFieldId}_${selectedGroups[1].id}`);
            const calculateResult = isUndefined(group1) || isUndefined(group2) ? 0 : ((Number(group1) - Number(group2)) / Number(group2)) * 100;
            tableEntries.set(this.analyticsUtils.getSlectedGroupColumnName(selectedGroups), RandomUtils.roundUp(calculateResult).toString());
        }
        return tableEntries;
    }

    private prepareProjection() {
        this.datapointProjection = {
            datasetID: this._dataset.id,
            fields: [],
            formulas: [],
            links: [],
        };
        if (this._dataset.geometryType !== DatasetGeometryType.NONE) {
            this.datapointProjection.geometryPrecision = 25;
        }

        // ⭐ NEW: Build links for climate overlays (from selectedFieldsByDataset)
        this.selectedFieldsByDataset.forEach((fields, datasetId) => {
            if (datasetId !== this._dataset.id) {
                let linkProjection: DatapointProjection = {
                    datasetID: datasetId,
                    fields: fields.map((field) => field.id),
                };
                this.datapointProjection.links.push(linkProjection);
            }
        });
        
        // ⭐ NEW: If ranking field is from climate overlay, add it to the appropriate link
        if (this.selectedRankingField && this.selectedRankingFieldOverlay) {
            const overlayDatasetId = this.selectedRankingFieldOverlay.id;
            let existingLink = this.datapointProjection.links.find(link => link.datasetID === overlayDatasetId);
            
            if (existingLink) {
                // Add ranking field to existing link if not already present
                if (!existingLink.fields.includes(this.selectedRankingField.id)) {
                    existingLink.fields.push(this.selectedRankingField.id);
                }
            } else {
                // Create new link for ranking field overlay
                this.datapointProjection.links.push({
                    datasetID: overlayDatasetId,
                    fields: [this.selectedRankingField.id],
                });
            }
        }

        // ✅ EXISTING LOGIC - Keep as-is
        this.selectedFields.forEach((field) => {
            this.datapointProjection.fields.push(field.id);
        });
        
        // ⭐ UPDATED: Only add ranking field to projection.fields if it's NOT from an overlay
        if (this.selectedRankingField && !this.selectedRankingFieldOverlay) {
            this.datapointProjection.fields.push(this.selectedRankingField.id);
        }
        if (this.selectedFormula) {
            this.datapointProjection.formulas.push(this.selectedFormula);
        }
    }

    onRankingFieldSelection(fieldSelected: boolean, field: DatasetField, overlay?: Dataset) {
        if (fieldSelected) {
            this.clearSelectedFormula();
            this.selectedRankingField = field;
            this.selectedRankingFieldOverlay = overlay;

            if (!overlay) {
                const idx = this.findFieldIndex(this._dataset.fields, field);
                if (idx !== -1) this._dataset.fields[idx].selected = true;
            }

            const existing = this.selectedFields.find((f) => f.id === field.id);
            if (existing) {
                const index = this.findFieldIndex(this.selectedFields, field);
                this.selectedFields.splice(index, 1);
            }
        } else {
            // Clear current selection
            this.selectedRankingField = undefined;
            this.selectedRankingFieldOverlay = undefined;

            if (!overlay) {
                const idx = this.findFieldIndex(this._dataset.fields, field);
                if (idx !== -1) this._dataset.fields[idx].selected = false;
            }
        }
    }

    findFieldIndex(array: DatasetField[], field: DatasetField): number {
        return array.findIndex((x) => x.id === field.id);
    }

    getDisabledRankingTreeNode(node) {
        if (!isUndefined(node.params)) {
            const field = node.params.field;
            if (node.params.callType === "formula") {
                return (
                    (this.selectedFormula &&
                        this.selectedFormula.id !== field.id) ||
                    this.selectedRankingField !== undefined
                );
            }

            const selectedIsOverlay = !!this.selectedRankingFieldOverlay || !!(this.selectedRankingField as any)?.datasetId;
            const selectedOverlayId = this.selectedRankingFieldOverlay?.id || (this.selectedRankingField as any)?.datasetId;
            const currentIsOverlay = !!node.params.overlay;
            const currentOverlayId = node.params.overlay?.id;

            if (this.selectedFormula !== undefined) {
                return true;
            }

            if (this.selectedRankingField) {
                if (selectedIsOverlay && currentIsOverlay) {
                    return !(selectedOverlayId === currentOverlayId && this.selectedRankingField?.id === field.id);
                }
                if (selectedIsOverlay !== currentIsOverlay) {
                    return true;
                }
                return this.selectedRankingField?.id !== field.id;
            }
        }
        return false;
    }

    onRankingFieldModelChangeEvent(node) {
        if (!isUndefined(node.params)) {
            if (node.params.callType === "formula") {
                // Handle formula selection from tree
                if (node.selected) {
                    this.clearSelectedRankingField();
                    this.selectedFormula = node.params?.field;
                    // Mark the node as selected after clearing
                    node.selected = true;
                    this.datapointObject.marksSelected(
                        this.rankingDataSource.data,
                        node.params?.field?.id
                    );
                } else {
                    this.selectedFormula = undefined;
                    this.datapointObject.clearAllSelected(this.rankingDataSource.data);
                }
                this.changeDetector.detectChanges();
                return;
            }

            const isOverlayNode = !!node.params?.overlay;
            if (!isOverlayNode) {
                this.onRankingFieldSelection(node.selected, node.params?.field);
            } else {
                this.onRankingFieldSelection(node.selected, node.params?.field, node.params?.overlay);
            }
        }
    }

    private clearSelectedFormula() {
        this.selectedFormula = undefined;
        this._formulas.forEach((formula) => (formula.selected = false));
    }

    private clearSelectedRankingField() {
        this.selectedRankingField = undefined;
        this._dataset.fields.forEach((datasetField) => (datasetField.selected = false));
        this.datapointObject.clearAllSelected(this.rankingDataSource.data);
    }

    setSelectedFormula(formula: WorkspaceItem) {
        const selectedFormula = this._formulas.find(
            (f) => Number(f.id) === Number(formula.id)
        );
        if (!selectedFormula) {
            // Formula has been deleted, clear the selection and show error
            this.selectedFormula = undefined;
            this.notif.error(
                `Formula "${formula.name}" has been deleted. Please select a different formula or field.`
            );
            return;
        }
        this.selectedFormula = selectedFormula;
        this.selectedFormula.selected = true;
        this.datapointObject.marksSelected(
            this.rankingDataSource.data,
            this.selectedFormula.id
        );
    }

    private isMissingValue(value: any): boolean {
        return isUndefined(value) || value === null || value === "";
    }

    getSelectedFormula(): WorkspaceItem {
        return this.selectedFormula;
    }

    isTwoDimensionReport(): boolean {
        return false;
    }

    getTableReportHeader(): TableColumn[] {
        let columns: TableColumn[] = [];
        columns.push({
            id: this.RANKING_COLUMN_ID,
            name: "Ranking",
            type: TableColumnType.INTEGER,
            horizontalAlignment: TableColumnAlignment.LEFT,
        });
        this.dynamicColumns.forEach((columnName: string, key: string) => {
            const columnId = this.isComparisonModeActivated ? key.split('_')[0] : key;
            const selectedField = this.selectedFields.find(element => element.id == columnId);
            if (selectedField !== undefined) {
                    columns.push({
                        id: key,
                        name: columnName,
                        type: TableColumnType.TEXT, // even of  type is number, we use TEXT to cover the 'N/A' value as well
                        horizontalAlignment: TableColumnAlignment.RIGHT,
                    });
            } else {
                    // we consider this cases -: this.selectedRankingField.id == columnId || (this.selectedFormula && this.selectedFormula.id.toString() == columnId)
                    columns.push({
                        id: key,
                        type: TableColumnType.DECIMAL,
                        name: columnName,
                        horizontalAlignment: TableColumnAlignment.RIGHT,
                    });
                }
        });
        return columns;
    }

    getTableReportFooter(): TableRow {
        let cells: TableCell[] = [];
        cells.push({ id: this.TOTAL_COLUMN_ID, value: "Total" });
        this.dynamicColumns.forEach((columnName: string, columnId: string) => {
            const value = this.sumsByFieldId.get(columnId);
            if (value !== undefined) {
                cells.push({
                    id: columnId,
                    value: RandomUtils.roundUp(value)
                });
            } else {
                cells.push({ id: this.BLANK_COLUMN_ID, value: "" });
            }
        })
        // cells.splice(cells.length - 1, 1); // we need to add only N-1 empty spaces
        return { cells: cells };
    }

    getTableReportRows(): TableRow[] {
        let rows: TableRow[] = [];
        this.downloadReportData.map((row) => {
            let columns: TableCell[] = [];
            columns.push({
                id: this.RANKING_COLUMN_ID,
                value: row.ranking,
            });
            this.dynamicColumns.forEach((value, key) => {
                columns.push({
                    id: key,
                    value: RandomUtils.roundUp(row.dynamicFieldValuesByIds.get(key)),
                });
            });
            rows.push({ cells: columns });
        });

        return rows;
    }

    getTableReportDownloadRequest(): DownloadReportItem {
        if (this.dataIsReady) {
            let reportHeader = this.getTableReportHeader();
            let reportRows = this.getTableReportRows();
            let reportFooter = this.getTableReportFooter();
            let title = this.reportName || "Ranking";

            return new DownloadReportTableRequest(
                title,
                reportHeader,
                reportRows,
                reportFooter
            );
        } else {
            return null;
        }
    }

    getDisplayType(): ReportDisplayType {
        return this.reportSubType;
    }

    getChartReportDownloadRequest(): DownloadReportItem {
        return undefined;
    }

    getReportDownloadRequest(): DownloadReportItem {
        if (this.getDisplayType() === ReportDisplayType.TABLE) {
            return this.getTableReportDownloadRequest();
        } else if (
            this.getDisplayType() === ReportDisplayType.BAR_CHART ||
            this.getDisplayType() === ReportDisplayType.PIE_CHART
        ) {
            return this.getChartReportDownloadRequest();
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    setSelectedRankingField(selectedRankingField: DatasetField, overlayId?: string) {
        // If overlay field, find overlay and mark only that field in tree
        if (overlayId) {
            const overlay = this.findOverlayById(this._climateOverlays, overlayId);
            if (overlay) {
                this.selectedRankingFieldOverlay = overlay;
                this.selectedRankingField = selectedRankingField;
                this.rankingDataSource.data = this.setOnlySelectedField(
                    this.rankingDataSource.data,
                    selectedRankingField.id,
                    overlayId
                );
                return;
            }
        }

        // Primary dataset field path
        const selectedField = this.datasetFields.find((f) => f.id === selectedRankingField.id);
        if (selectedField) {
            this.selectedRankingField = selectedField;
            selectedField.selected = true;
            this.rankingDataSource.data = this.setOnlySelectedField(
                this.rankingDataSource.data,
                selectedRankingField.id
            );
        }
    }

    /**
     * Immutable update helpers for ranking tree selection
     */
    private clearAllSelected(data: any[]): any[] {
        if (!data) return data;
        return data.map(item => ({
            ...item,
            selected: false,
            params: item.params ? { ...item.params, selected: false } : item.params,
            children: item.children ? this.clearAllSelected(item.children) : item.children
        }));
    }

    private setOnlySelectedField(data: any[], targetId: number | string, overlayId?: string): any[] {
        if (!data) return data;
        const recurse = (items: any[]): any[] => items.map(item => {
            const isMatch = overlayId
                ? (item.params?.field?.id?.toString() === targetId.toString() && item.params?.overlay?.id === overlayId)
                : (item.params?.field?.id?.toString() === targetId.toString());
            const newItem: any = {
                ...item,
                selected: !!isMatch,
                params: item.params ? { ...item.params, selected: !!isMatch } : item.params
            };
            if (item.children && item.children.length) newItem.children = recurse(item.children);
            return newItem;
        });
        return recurse(data);
    }
    
    /**
     * Recursively find overlay by ID from climate overlay groups
     */
    private findOverlayById(overlayGroups: any[], overlayId: string): Dataset | null {
        if (!overlayGroups) return null;
        
        for (const group of overlayGroups) {
            // Check overlays in current group
            if (group.overlays) {
                const found = group.overlays.find(overlay => overlay.id === overlayId);
                if (found) return found;
            }
            
            // Check children recursively
            if (group.children && group.children.length > 0) {
                const found = this.findOverlayById(group.children, overlayId);
                if (found) return found;
            }
        }
        
        return null;
    }

    setSelectedFields(selectedFields: DatasetField[]) {
        selectedFields.forEach((field) => {
            let datasetField = this.datasetFields.find(
                (f) => f.id === field.id
            );
            if (datasetField) {
                datasetField.selected = true;
                this.datapointObject.markSelected(this.columnsToDisplayDataSource.data, datasetField.id);
                this.selectedFields.push(datasetField);
            }
        });
    }
    
    /**
     * Restore selectedFieldsByDataset Map when loading saved report
     * Handles climate overlay column fields
     */
    setSelectedFieldsByDataset(
        selectedFieldsByDataset: Map<string, DatasetField[]>
    ) {
        selectedFieldsByDataset.forEach((fields, datasetId) => {
            // ⭐ Use datasetId from field object if available, otherwise use Map key
            const actualDatasetId = (fields.length > 0 && (fields[0] as any).datasetId) 
                ? (fields[0] as any).datasetId 
                : datasetId;
            
            // Find the overlay dataset from climate overlays
            const overlay = this.findOverlayById(this._climateOverlays, actualDatasetId);
            
            if (overlay) {
                // Mark fields as selected in the tree
                fields.forEach((field) => {
                    // ⭐ FIXED: Pass overlayId to markSelected to only mark fields from this specific overlay
                    this.datapointObject.markSelected(
                        this.columnsToDisplayDataSource.data,
                        field.id,
                        actualDatasetId
                    );
                });
                
                // Store in selectedFieldsByDataset Map using actual dataset ID
                this.selectedFieldsByDataset.set(actualDatasetId, fields);
            }
        });
    }

    sortFields(fields: DatasetField[]) {
        fields.sort((item1, item2) => {
            if (item1 && item1.name && item2 && item2.name) {
                return item1.name
                    .trim()
                    .toLowerCase()
                    .localeCompare(item2.name.trim().toLowerCase());
            }
        });
        return fields;
    }

    resetNRISelectedFlag() {
        this._nriFields.forEach((outerElement) => {
            outerElement.child.forEach((element) => {
                element.child.selected = false;
            });
        });
    }

    getSaveButtonLabel() {
        return this.isDashboardCall ? "Save" : "Save to Dashboard";
    }

    getSaveAsButtonLabel() {
        return this.isDashboardCall ? "Save as" : "Save as Dashboard";
    }

    // isTensorFlight(key: string) {
    //     return key.toUpperCase() === "TENSORFLIGHT";
    // }

    isE2Value(key: string) {
        return key.toUpperCase() === "E2VALUE";
    }

    getDisplayName(node) {
        return this.datapointObject.getDisplayName(node);
    }

    get DatasetGeometryType() {
        return DatasetGeometryType;
    }

    // Cross-disable: if a primary dataset field is selected in columns, disable it in ranking
    // Only applies to primary location fields, not overlays
    isRankingNodeDisabledByColumns(node: any): boolean {
        if (!node?.params || node.params?.overlay) {
            return false; // overlays are not cross-disabled with columns
        }
        const fieldId = node.params?.field?.id;
        if (!fieldId) return false;
        // Do not disable the currently selected ranking field itself
        if (this.selectedRankingField && this.selectedRankingField.id === fieldId) {
            return false;
        }
        // Only disable if ranking field is NOT an overlay (i.e., it's a primary field)
        if (this.selectedRankingField && this.selectedRankingFieldOverlay) {
            return false; // ranking field is an overlay, so don't cross-disable
        }
        return this.selectedFields && this.selectedFields.some(f => f.id === fieldId);
    }

    collapseAll(): void {
        this.rankingTreeControl.collapseAll();
        this.columnsToDisplayTreeControl.collapseAll();
    }

    isLocationTypeApplication() {
        return this._dataset.application === MaptycsApplication.LOCATIONS;
    }

    getSelectedGroups() {
        return [...AnalyticsUtils.getSelectedNodes(this._compareGroupsStrcuture), ...AnalyticsUtils.getSelectedNodes(this._withGroupsStrcuture)];
    }

    showCheckButton(): boolean {
        return this.isComparisonModeActivated ?
        (this.selectedRankingField || this.selectedFormula) && (this.selectedFields.length > 0 || this.selectedFieldsByDataset.size > 0 || this.hasOverlayColumnsSelected()) && this.noOfItems > 0 && this.getSelectedGroups().length === AnayticsConstants.MAX_GROUP_SELECT_LIMIT :
        (this.selectedRankingField || this.selectedFormula) && (this.selectedFields.length > 0 || this.selectedFieldsByDataset.size > 0 || this.hasOverlayColumnsSelected()) && this.noOfItems > 0;
    }

    // Detect any selected climatology overlay columns directly from tree (fallback if Map wasn't mutated yet)
    private hasOverlayColumnsSelected(): boolean {
        const scan = (nodes: any[]): boolean => {
            if (!nodes) return false;
            for (const n of nodes) {
                if (n?.params?.overlay && n?.selected) return true;
                if (n?.children && scan(n.children)) return true;
            }
            return false;
        };
        return scan(this.columnsToDisplayDataSource?.data || []);
    }

    getFormattedName(name, isLengthChecked: boolean = true) {
        return AnalyticsUtils.getFormattedName(name, isLengthChecked);
    }

    onCheckboxChange(event: MatCheckboxChange, type: string) {
        const result = AnalyticsUtils.groupSelectionEvent(event, type, this._compareGroups, this._withGroups);
        this._compareGroups = result.compareGroups;
        this._withGroups = result.withGroups;
    }

    toggleItemExpansion(item: TreeNode) {
        item.expanded = !item.expanded;
    }

    toggleItem(event: MatCheckboxChange, item: TreeNode, section: 'compare' | 'with') {
        if(event.checked && section == 'compare') {
            this.compareGroupCheckEvent(this._withGroupsStrcuture, item.id, 'with');
            this.compareGroupCheckEvent(this._compareGroupsStrcuture, item.id, 'compare');
        } else if(event.checked && section == 'with') {
            this.withGroupCheckEvent(this._compareGroupsStrcuture, item.id, 'compare');
            this.withGroupCheckEvent(this._withGroupsStrcuture, item.id, 'with');
        } else if(!event.checked && section == 'compare') {
            let selectedItem = AnalyticsUtils.getSelectedNodes(this._withGroupsStrcuture);
            const withItem = selectedItem.length > 0 ? selectedItem[0] : undefined;
            this.compareGroupUnCheckEvent(this._withGroupsStrcuture, item.id, 'with', withItem);
            this.compareGroupUnCheckEvent(this._compareGroupsStrcuture, item.id, 'compare', withItem);
        } else if(!event.checked && section == 'with') {
            let selectedItem = AnalyticsUtils.getSelectedNodes(this._compareGroupsStrcuture);
            const compareItem = selectedItem.length > 0 ? selectedItem[0] : undefined;
            this.withGroupUnCheckEvent(this._compareGroupsStrcuture, item.id, 'compare', compareItem);
            this.withGroupUnCheckEvent(this._withGroupsStrcuture, item.id, 'with', compareItem);
        }
    }

    compareGroupCheckEvent(nodes: TreeNode[], id: number, section: string) {
        for (const node of nodes) {
            if ((section === 'compare' && node.id !== id) || (section === 'with' && node.id == id)) {
                node.disabled = true;
            }
            if (node.children) {
                this.compareGroupCheckEvent(node.children, id, section);
            }
        }
    }

    withGroupCheckEvent(nodes: TreeNode[], id: number, section: string) {
        for (const node of nodes) {
            if ((section === 'compare' && node.id === id) || (section === 'with' && node.id !== id)) {
                node.disabled = true;
            }
            if (node.children) {
                this.withGroupCheckEvent(node.children, id, section);
            }
        }
    }

    compareGroupUnCheckEvent(nodes: TreeNode[], id: number, section: string, withItem: any) {
        for (const node of nodes) {
            if ((section === 'with' && node.id == id) && withItem == undefined) {
                node.disabled = false;
            } else if (section === 'compare' && (withItem !== undefined && (node.id !== withItem.id && node.id !== id) ||  withItem == undefined)) {
                node.disabled = false;
            } else if (section === 'compare' && withItem == undefined) {
                node.disabled = false;
            }
            if (node.children) {
                this.compareGroupUnCheckEvent(node.children, id, section, withItem);
            }
        }
    }

    withGroupUnCheckEvent(nodes: TreeNode[], id: number, section: string, compareItem: any) {
        for (const node of nodes) {
            if ((section === 'compare' && node.id == id) && compareItem == undefined) {
                node.disabled = false;
            } else if (section === 'with' && (compareItem !== undefined && (node.id !== compareItem.id && node.id !== id) ||  compareItem == undefined)) {
                node.disabled = false;
            } else if (section === 'with' && compareItem == undefined) {
                node.disabled = false;
            }
            if (node.children) {
                this.withGroupUnCheckEvent(node.children, id, section, compareItem);
            }
        }
    }

}
